import { render, staticRenderFns } from "./TrayIcon.vue?vue&type=template&id=0b00fefc&"
import script from "./TrayIcon.vue?vue&type=script&lang=js&"
export * from "./TrayIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports